<span>
  Since its inception in 2011, the Military Spouse Employment Partnership has
  grown to include more than
  <strong class="highlight">950</strong>
  employers and nonprofit organizations. In that time, MSEP partners have
  reported hiring more than
  <strong class="highlight">360,000</strong>
  military spouses!
</span>
